import { useTranslation } from "react-i18next";
import { RootState } from "../../store/store";
import { useSelector } from "react-redux";
import { useContext, useState } from "react";
import { SocketContext } from "../../context/socket";
import propagandaPlayer from "../../assets/propaganda-player.svg";

export function Respond() {
  const { t } = useTranslation();
  const [hide, setHide] = useState(false);
  const responses = useSelector((state: RootState) => state.player.responses);
  const room = useSelector((state: RootState) => state.player.code);
  const name = useSelector((state: RootState) => state.player.playerName);
  const lastAnswer = useSelector((state: RootState) => state.player.lastAnswer);
  const socket = useContext(SocketContext);
  const [selected, setSelected] = useState(-1);

  const sendAnswer = (response: string, index: number) => {
    setSelected(index);
    socket.emit("MY_RESPONSE", {
      roomId: room,
      response: response,
      name: name,
    });
    setHide(true);
  };

  return (
    <div
      id="resp"
      className="player-game-min relative z-0 w-screen overflow-x-hidden overflow-y-auto bg-question-background bg-cover"
    >
      {hide && (
        <div className="flex min-h-[50dvh] w-full flex-col items-center justify-center px-4 py-8 player-game-safe-y">
          <img
            alt="propaganda logo"
            className="z-30 h-24 w-auto shrink object-contain xs:h-32 desktop:h-44"
            src={propagandaPlayer}
          />
        </div>
      )}
      {!hide && (
        <div className="flex w-full flex-col items-center px-3 py-4 player-game-safe-y">
          <h3 className="z-30 mx-4 mt-2 text-center font-Cairo text-2xl font-bold text-dark-blue xs:text-3xl desktop:mx-24 desktop:text-7xl">
            {t("respond.choose")}
          </h3>
          {responses.length > 5 && (
            <div className="mt-4 grid w-full max-w-2xl grid-cols-2 gap-2 px-1 sm:gap-3">
              {responses
                .filter((item) => lastAnswer !== item)
                .map((response, index) => {
                  return (
                    <button
                      key={index}
                      className="min-h-[3.5rem] w-full rounded-xl border-2 border-white bg-orange px-2 py-2 text-center text-lg font-bold text-dark-blue phone:mb-1 xs:text-xl disabled:opacity-50"
                      disabled={selected === index}
                      onClick={() => sendAnswer(response, index)}
                    >
                      {response}
                    </button>
                  );
                })}
            </div>
          )}
          {responses.length < 6 && (
            <div className="mt-4 grid w-full max-w-xl flex-1 gap-2 overflow-y-auto px-1 pb-6">
              {responses
                .filter((item) => lastAnswer !== item)
                .map((response, index) => {
                  return (
                    <button
                      key={index}
                      className="min-h-[3rem] w-full rounded-xl border-2 border-white bg-orange px-2 py-2 text-center font-Cairo text-lg font-semibold text-dark-blue xs:text-2xl phone:mb-2 disabled:border-sky-600 disabled:shadow-lg"
                      disabled={selected === index}
                      onClick={() => sendAnswer(response, index)}
                    >
                      {response}
                    </button>
                  );
                })}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
